module.exports = __webpack_public_path__ + "img/price-click-3.c7ed8541.webp";